<template>
    <div class="home">
    </div>
  </template>
  
  <script setup>
  </script>
  
  <style lang="scss" scoped>
  .home {
    background-image: url(https://p4.ssl.qhimg.com/t110b9a93015cbbfb121eccd376.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    // height: 300px;
    aspect-ratio: 43 / 36;
    position: relative;
  }
  </style>
  